import { Voter } from "@activecollab/security";
import { MEMBER_PERMISSIONS } from "~/records/record.project";
import { isClient, isFinancialManager, isMemberWithoutPermissions, isOwner, isPowerClient } from "~/utils/userHelper";

export class ProjectVoter extends Voter {
  attributes = [
    "can_track_time_for_others",
    "can_track_expense_for_others",
    "can_add_task",
    "can_add_task_list",
    "can_collaborate",
  ];

  supports(attribute, subject) {
    if (!this.attributes.includes(attribute)) {
      return false;
    }
    return subject && subject.class === "Project";
  }

  voteOnAttribute(attribute, subject, user) {
    switch (attribute) {
      case "can_track_expense_for_others":
      case "can_track_time_for_others": {
        if (!subject || !subject.is_tracking_enabled) {
          return false;
        }
        if (user.class === "Owner") {
          return true;
        }
        if (user.id === subject.leader_id) {
          return true;
        }
        if (isFinancialManager(user) && subject.members.includes(user.id)) {
          return true;
        }
        return false;
      }
      case "can_add_task":
      case "can_add_task_list": {
        if (subject?.is_trashed) {
          return false;
        }

        if (subject?.is_completed) {
          return false;
        }

        if (isOwner(user)) {
          return true;
        }

        if (isClient(user) && !isPowerClient(user)) {
          return false;
        }

        if (
          isMemberWithoutPermissions(user) &&
          subject.leader_id !== user?.id &&
          subject.member_permissions === MEMBER_PERMISSIONS.STRICT
        ) {
          return false;
        }

        return subject?.members.includes(user?.id);
      }
      case "can_collaborate": {
        if (isClient(user) && !isPowerClient(user)) {
          return false;
        }

        return !(
          isMemberWithoutPermissions(user) &&
          subject.leader_id !== user?.id &&
          subject.member_permissions === MEMBER_PERMISSIONS.STRICT
        );
      }
    }
    throw new Error("This code should not be reached!");
  }
}
